import { useCallback, useEffect, useState } from "react";

export type ChatScreenSize = "desktop" | "tablet" | "mobile";

const getScreenSize = (): ChatScreenSize => {
  if (window.innerWidth <= 576) return "mobile";
  if (window.innerWidth <= 768) return "tablet";
  return "desktop";
};

export const useChatLayoutState = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [isMobileSidebarVisible, setIsMobileSidebarVisible] = useState(false);
  const [screenSize, setScreenSize] = useState<ChatScreenSize>("desktop");
  const [bannerHeight, setBannerHeight] = useState(0);

  useEffect(() => {
    const handleResize = () => setScreenSize(getScreenSize());

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSidebarToggle = useCallback(() => {
    if (screenSize === "mobile") {
      setIsMobileSidebarVisible((isVisible) => !isVisible);
    } else {
      setIsSidebarVisible((isVisible) => !isVisible);
    }
  }, [screenSize]);

  const handleSidebarCollapse = useCallback(() => {
    setIsSidebarVisible(false);
  }, []);

  const handleOverlayClick = useCallback(() => {
    setIsMobileSidebarVisible(false);
  }, []);

  return {
    bannerHeight,
    handleOverlayClick,
    handleSidebarCollapse,
    handleSidebarToggle,
    isMobileSidebarVisible,
    isSidebarVisible,
    screenSize,
    setBannerHeight,
    setIsMobileSidebarVisible,
  };
};
